import React, { Component } from "react";
import TitleBar from "../../titleBar";
import TwoCol from "../../containers/twoCol";
import Vars from "../../config/vars";
class ImageGridBlock extends Component {
  returnImages() {
    return this.props.rowData.map((square, index) => (
      <div
        key={index}
        className={"image" + index}
        style={{
          width: "45%",
          height: (window.innerWidth * 0.5 - 39) * 0.45 + "px",
          backgroundImage: "url('" + square.field_image.uri + "')",
          float: "left",
          margin: (index + 1) % 2 !== 0 ? "24px 24px 24px 24px" : "24px 0px",
        }}
      ></div>
    ));
  }

  render() {
    const titleStyles = this.props.blockStyle.attributes
      .field_title_color_font[0];
    const titleClassName = this.props.blockStyle.name.replace(" ", "-");
    return (
      <TwoCol
        className="col"
        padding={"120px " + Vars.gutter + " 120px 0px"}
        display="block"
        styles={{
          fontSize: "19px",
          lineHeight: " 19px",
          border: "0px dashed #cc00cc",
          gridGap: "0px",
        }}
      >
        {this.props.field_boolean_2 !== "0" ? (
          <TitleBar
            className={titleClassName}
            color={titleStyles.field_color_1}
            bgc={titleStyles.field_bgcolor_1}
            fontFamily={titleStyles.field_font_1.fontName}
            max="19"
            min="16"
            container="Left"
            tag="p"
          >
            {this.props.title}
          </TitleBar>
        ) : null}
        {this.returnImages()}
      </TwoCol>
    );
  }
}

export default ImageGridBlock;
